/**
 * Quick-buy cart notification: "View cart" should stay in the shopping flow.
 * Close the quick-buy drawer and open the floating mini-cart instead of /cart.
 *
 * Race (intermittent): each product card has multiple toggle-buttons for the same
 * quick-buy-drawer. On openable-element:open they all set aria-expanded=true, and
 * each false→true transition calls drawer.open=true again. QuickBuyDrawer keeps
 * href, so each open=true starts another _load(); when that fetch resolves it
 * always setAttribute("open") — even if we already closed for the cart handoff.
 * Result: mini-cart opens, then QB reopens on top (cart appears "behind").
 *
 * Guard: crush QB reopens for as long as the mini-cart handoff is active (until
 * mini-cart closes). No wall-clock timer — slow duplicate _load is still covered
 * while the cart is open, and intentional same-drawer opens work after dismiss.
 */
(function () {
  if (window.__boaQuickBuyViewCartInitialized) {
    return;
  }
  window.__boaQuickBuyViewCartInitialized = true;

  document.addEventListener("click", function (event) {
    var link = event.target.closest("a.cart-notification__view-cart");
    if (!link) {
      return;
    }

    var quickBuyDrawer = link.closest("quick-buy-drawer");
    if (!quickBuyDrawer) {
      return;
    }

    var miniCart = document.getElementById("mini-cart");
    if (!miniCart || window.themeVariables?.settings?.cartType !== "drawer") {
      return;
    }

    // Already handing this drawer off — ignore stacked View cart clicks.
    if (quickBuyDrawer.__boaViewCartHandoff) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var handedOff = false;
    var guardActive = false;

    var blockReopen = function (openEvent) {
      if (!guardActive || openEvent.target !== quickBuyDrawer) {
        return;
      }
      quickBuyDrawer.open = false;
    };

    var endGuard = function () {
      if (!guardActive) {
        return;
      }
      guardActive = false;
      quickBuyDrawer.removeEventListener("openable-element:open", blockReopen);
      miniCart.removeEventListener("openable-element:close", endGuard);
      // Late setAttribute may race this close; don't leave QB open after handoff.
      if (quickBuyDrawer.hasAttribute("open")) {
        quickBuyDrawer.open = false;
      }
      delete quickBuyDrawer.__boaViewCartHandoff;
    };

    var finishHandOff = function () {
      if (handedOff) {
        return;
      }
      handedOff = true;

      // Crush any open that landed between close and this turn (focus-trap
      // returnFocus is setTimeout 0; duplicate _load may still be in flight).
      quickBuyDrawer.open = false;
      miniCart.open = true;

      guardActive = true;
      quickBuyDrawer.addEventListener("openable-element:open", blockReopen);
      miniCart.addEventListener("openable-element:close", endGuard);
    };

    quickBuyDrawer.__boaViewCartHandoff = true;

    if (quickBuyDrawer.open) {
      quickBuyDrawer.addEventListener(
        "openable-element:close",
        function () {
          // After focus-trap deactivate's delayed returnFocus (setTimeout 0).
          setTimeout(finishHandOff, 0);
        },
        { once: true }
      );
      quickBuyDrawer.open = false;
      return;
    }

    setTimeout(finishHandOff, 0);
  });
})();
